import * as React from 'react';
import * as styles from './styles.css';

import { LinkButton } from '@cian/ui-kit/button';
import { Header2, Header3, InlineText1 } from '@cian/ui-kit/typography';

import { NotDesktop, Desktop } from '../Responsive';

export interface IDetailsProps {
  url: string;
  onClick?(): void;
}

export function Details({ url, onClick }: IDetailsProps) {
  return (
    <div className={styles['container']}>
      <h3 className={styles['title']}>
        <NotDesktop>
          <Header3 color="white_100">Нужно больше информации?</Header3>
        </NotDesktop>
        <Desktop>
          <Header2 color="white_100">Нужно больше информации?</Header2>
        </Desktop>
      </h3>
      <div className={styles['description']}>
        <NotDesktop>
          <InlineText1 color="white_100">
            Предоставим полный доступ к данным о рынке недвижимости, создадим уникальные модели и подготовим отчеты
          </InlineText1>
        </NotDesktop>
        <Desktop>
          <InlineText1 color="white_100">
            Предоставим полный доступ к данным о рынке недвижимости, создадим уникальные модели
            <br />и подготовим отчеты
          </InlineText1>
        </Desktop>
      </div>
      <div>
        <LinkButton href={url} onClick={onClick} theme="fill_white_primary" size="M">
          Узнать подробности
        </LinkButton>
      </div>
    </div>
  );
}
